export const and = (r1, r2) => (...args) => [r1, r2].every((rule) => rule(...args));
export const or = (r1, r2) => (...args) => [r1, r2].some((rule) => rule(...args));
export const not = (r1) => (...args) => !r1(...args);
export const plotOrOrganizationRoleBearerRule = (ruleName, ruleImplementation) => (subject, op, object, args) => {
    if (!('plot' in args) && !('organization' in args)) {
        throw new Error(`You must provide a plot or an organization to ensure the ${ruleName} access rule is correctly checked, the context of the access was the following: ${JSON.stringify({
            ruleName,
            subject,
            op,
            object
        }, null, 4)}`);
    }
    else {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const roleBearer = (args.plot || args.organization);
        return ruleImplementation(subject, op, object, { roleBearer });
    }
};
